// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
import AxiosInstance from 'config/apiServiceApiGateway'

export const getVendors = (params: any): any =>
  AxiosInstance.Get({
    url: `/commercial/internal/v1/vendors`,
    params,
    convertResponse: true,
    convertRequest: true,
  })

export const getVendorDetails = (vendor_id: any): any =>
  AxiosInstance.Get({
    url: `/erp/internal/v2/vendor/${vendor_id}`,
  })

export const createNewVendor = (data: any): any =>
  AxiosInstance.Post({
    url: `/erp/internal/v2/vendor`,
    data,
  })

export const putVendor = (data: any): any =>
  AxiosInstance.Put({
    url: `/erp/internal/v2/vendor`,
    data,
  })
